<template>
  <div>
    <tab :type.sync="type" @tabSwitch="tabSwitch"/>
    <div class="account" v-if="currentBindinList.length">
      <div class="banner">
        <div class="text-box">
          <div class="title">{{type == 1 ? '提现': '入网签约'}}账户管理</div>
          <div class="title-mini">设置绑定{{type == 1 ? '提现': '入网签约'}}人</div>
        </div>
      </div>
      <!-- <img class="banner" src="@/assets/images/banner.png" /> -->
      <div class="content">
        <div class="title">已绑定的提现人</div>
        <div class="list" v-for="(item,index) in currentBindinList" :key="index">
          <div class="list-left">
            <div class="name">({{item.bindingAccount}}){{item.bindingUserName}}</div>
            <div class="number">{{item.bindingTelephone}}</div>
          </div>
          <div class="list-right" @click="unbind(item)">取消绑定</div>
        </div>
        <p class="text" v-if="type == 1">
          特别提示：<br />
          1、提现人绑定<br />
          点击“绑定提现人”，选择要绑定的职员，向经销商要授权验证码，输入授权验证码即可完成绑定。<br />
          2、绑定提现授权验证码说明<br />
          绑定提现人时，系统以短信的方式，向经销商（老板）预留在公司建店档案上的手机号发送授权验证码。<br />
          3、更换提现人<br />
          经理或店长角色，可随时点击“取消绑定”更换提现人（先取消当前绑定的提现人，才能绑定新的提现人）。<br />
          4、风险提醒<br />
          提现人绑定成功后，该提现人可在“提现”菜单中自由提现，系统不再向经销商（老板）发送提现验证码，请谨慎绑定提现人。<br />
        </p>
        <p class="text" v-else>
          温馨说明：<br />
          什么情况下需要用到【授权入网操作人员】操作？<br />
          店面的《营业执照》上注明的法人本人，不能或不想亲自操作“银联商户号入网申请”；才需要授权店面其它人员，帮助营业执照上的法人，完成“银联商户号入网申请”操作。若授权，一切风险店面自己承担！<br />
          一、【授权入网操作人员】的操作步骤：<br />
          第1步：拓客宝中店长或经销商角色，点击【授权入网操作人员】按钮，选择授权人员，点【确定】<br />
          第2步：在弹出的授权窗口中，点击【获取验证码】，此时系统会以短信的方式，向经销商（老板）预留在公司建店档案上的手机号，发送授权验证码。<br />
          第3步：输入授权验证码，点【确定】即完成授权。此时授权人才可以代替法人进行商户号入网资料提交。<br />
          二、如何取消已授权的入网操作人员？<br />
          拓客宝系统中的经销商或店长角色，随时点击该页面上的“取消授权”即可取消授权。
        </p>
        <div class="footer">
          <van-button  
            class="botton" color="#FF6B59"
            @click="accountSet"
          >
            绑定账号
          </van-button>
        </div>
        <div style="height: 84px"></div>
      </div>
    </div>
    <div v-else>
      <no-account @bindingAccount="accountSet" :type="type" />
    </div>
  </div>
</template>

<script>
import noAccount from './components/no-account'
import tab  from './components/tab'
export default {
  name: 'account',
  components: {
    noAccount,
    tab
  },
  data() {
    return {
      currentBindinList: [],
      isDisabled: true,
      checkbox: false,
      type: 1,
    }
  },
  mounted() {
    this.findBindingInfo()
    this.getCheckbox()
  },
  methods: {
    // 获取当前绑定人
    findBindingInfo() {
      this.$api.withdrawal.findBindingInfo({type: this.type})
        .then(res => {
          this.currentBindinList = res.data
        })
    },
    // 查询是否为多选
    getCheckbox() {
      this.$api.h5.queryPublicityData('h5_withdraw_binding')
        .then(res => {
          this.checkbox = JSON.parse(res.data.checkbox)
        })
    },
    unbind(item) {
      this.$dialog.confirm({
        title: '解绑',
        message: '正在解除当前微信的提现资格！<br/>请问是否解除绑定？',
      })
        .then(() => {
          this.$api.withdrawal.accountUnBinding({userId: item.bindingUserId, type: this.type})
            .then((res) => {
              if (res.data) {
                this.$toast('解绑成功')
                this.findBindingInfo()
              };
            });
        })
        .catch(() => {});
    },
    accountSet() {
      if (this.currentBindinList.length && !this.checkbox) {
        this.$toast({
          duration: 3000,
          message: this.type == 1 ? '当前已绑定提现人，请取消绑定后，再去更换绑定新提现人。' : '当前已绑定入网签约人，请取消绑定后，再去更换绑定新入网签约人。'
        })
        return
      }
      this.$router.push({
        path: '/account-set',
        query: {type: this.type}
      })
    },
    tabSwitch(type) {
      this.type = type
      this.findBindingInfo()
    }
  }
}
</script>

<style lang="stylus" scoped>
.account {
  .banner {
    width: 100%;
    height: 170px;
    color: #fff;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/32/E7/rB8LrWXxXwiAEJ7CAADax5jHRek191.png');
    background-size: 100% 100%;
    overflow: hidden;
    .text-box {
      margin: 36px 0 0 25px;
      .title {
        color: #fff;
        font-size: 28px;
        font-weight: bold;
      }
      .title-mini {
        font-size: 15px;
        margin-top: 6px;
      }
    }
  }
  .content {
    position: absolute;
    top: 195px;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 1px 3px 11px 1px rgba(187,187,187,0.4);
    border-radius: 17px 17px 0px 0px;
    background: #F4F4F4;
    .title {
      color: #999999;
      font-size: 28rpx;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 18px;
      background: #fff;
      border-radius: 8px;
      box-sizing: border-box;
      margin-bottom: 10px;
      .list-left {
        width: 200px;
        word-wrap: break-word;
        .name  {
          color: #333333;
          font-size: 15px;
          margin-bottom: 4px;
          font-weight: 400;
        }
      } 
      .list-right {
        width: 91px;
        height: 34px;
        color: #FF6B59;
        font-size: 15px;
        text-align: center;
        line-height 34px;
        background: #FFECEA;
        border-radius: 6px;
      }
    }
    .text {
      color #777
      font-size 12px
      line-height 18px
    }
    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content center;
      height: 84px;
      padding: 0 20px;
      background: #F4F4F4;
      .botton {
        width: 100%;
        margin-top: 10px;
        border-radius: 8px;
      }
    }
  }
}
</style>